import { render, staticRenderFns } from "./PDFJSViewer.vue?vue&type=template&id=e5fb2590&"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports